import React from 'react';
import { ApplicationView as view } from '@aha-app/mvc';
import ExampleField from 'components/card/components/CardContents/ExampleField';
import styles from './styles.module.css';
import { type ItemComponentProps } from 'javascripts/dnd/components/types';

const FieldPreview: React.FC<ItemComponentProps> = ({ dragItem }) => {
  return (
    <div className={styles.fieldPreview}>
      <ExampleField field={dragItem.item} />
    </div>
  );
};

export default view(FieldPreview);
